/**
 * 二级页面 路由配置
 */
export default [
    // 数字图书首页
    {
        path:'/t/books',
        name: 'DigitalBooks',
        component: () => import('@/views/topics/books/index'),
        meta: {
            title: '数字图书',
        }
    },
    // 数字图书列表页
    {
        path:'/t/books/list',
        name: 'DigitalBooksList',
        component: () => import('@/views/topics/books/list'),
        meta: {
            title: '数字图书',
        }
    },
    // 松雅讲坛首页
    {
        path:'/t/songya',
        name: 'SongYa',
        component: () => import('@/views/topics/songya/index'),
        meta: {
            title: '松雅讲坛',
        }
    },
    // 松雅讲坛列表页
    {
        path:'/t/songya/list',
        name: 'SongYaList',
        component: () => import('@/views/topics/songya/list'),
        meta: {
            title: '松雅讲坛',
        }
    },
    //  周末有戏
    {
        path:'/t/dramas',
        name: 'Dramas',
        component: () => import('@/views/topics/dramas/index'),
        meta: {
            title: '周末有戏',
        }
    },
    //  周末有戏列表页
    {
        path:'/t/dramas/list',
        name: 'DramasList',
        component: () => import('@/views/topics/dramas/list'),
        meta: {
            title: '周末有戏',
        }
    },
    //  艺术课堂
    {
        path:'/t/art-classroom',
        name: 'ArtClassroom',
        component: () => import('@/views/topics/art-classroom/index'),
        meta: {
            title: '艺术课堂',
        }
    },
    //  艺术课堂列表页
    {
        path:'/t/art-classroom/list',
        name: 'ArtClassroomList',
        component: () => import('@/views/topics/art-classroom/list'),
        meta: {
            title: '艺术课堂',
        }
    },
    // 文博场馆
    {
        path: '/t/attraction/list',
        name: 'ResourceAttractionList',
        component: () => import('@/views/resource/attraction/list'),
        meta: {
            title: '文博场馆'
        }
    },
    // 音乐视听
    {
        path: '/t/music/list',
        name: 'ResourceMusicList',
        component: () => import('@/views/resource/music/list'),
        meta: {
            title: '音乐视听列表'
        }
    },
]
